import { render, staticRenderFns } from "./AudienceBarChart.vue?vue&type=template&id=7b138c87&scoped=true"
import script from "./AudienceBarChart.vue?vue&type=script&lang=js"
export * from "./AudienceBarChart.vue?vue&type=script&lang=js"
import style0 from "./AudienceBarChart.vue?vue&type=style&index=0&id=7b138c87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b138c87",
  null
  
)

export default component.exports